import { Award, ShieldCheck, BadgeCheck } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../Reveal";

const ICONS = [BadgeCheck, ShieldCheck, Award];

export default function ProfileCerts({ certifications }) {
  if (!certifications?.length) return null;
  return (
    <section id="certifications" className="bg-paper py-24 md:py-32" data-testid="profile-certs">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <span className="label-mono text-gold">05 — Certifications</span>
          <h2 className="font-display text-4xl md:text-6xl font-semibold mt-4 tracking-tight max-w-4xl">Des références reconnues.</h2>
        </Reveal>
        <Stagger className="grid md:grid-cols-3 gap-5 mt-14">
          {certifications.map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <StaggerItem key={c.name}>
                <article className="h-full rounded-sm border hairline bg-white p-8 hover:border-gold hover:-translate-y-1 transition-all duration-500" data-testid={`cert-${i}`}>
                  <div className="w-12 h-12 rounded-full bg-gold/15 text-gold flex items-center justify-center">
                    <Icon size={22} />
                  </div>
                  <h3 className="font-display text-xl font-semibold mt-5">{c.name}</h3>
                  {c.detail && <p className="text-ink/55 text-sm mt-2">{c.detail}</p>}
                </article>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>
  );
}
